let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7S6qn")).then(() => parcelRequire('lmbDy'));